import { CartResponse, CartItemUpdate } from './o-shopping-cart.model';

export default class CartFetcher {
	private cartUrl: string;
	private addToCartUrl: string;
	private updateCartItemUrl: string;

	constructor(cartUrl: string, addToCartUrl: string, updateCartItemUrl: string) {
		this.cartUrl = cartUrl;
		this.addToCartUrl = addToCartUrl;
		this.updateCartItemUrl = updateCartItemUrl;
	}

	protected async fetch(input: RequestInfo, init?: RequestInit): Promise<CartResponse> {
		// console.log('fetch call to', input);
		const response = await fetch(input, init);

		if (!response.ok) {
			return {
				alert: {
					items: [
						{
							message: await response.text(),
							type: 'danger',
						},
					],
				},
				items: [],
				priceModifiers: [],
				cartUrl: this.cartUrl,
				addToCartUrl: this.addToCartUrl,
				updateCartItemUrl: this.updateCartItemUrl,
			};
		}

		return (await response.json()).data;
	}

	public async getCart(): Promise<CartResponse> {
		return this.fetch(new URL(this.cartUrl).toString());
	}

	public async updateCartItem(request: CartItemUpdate): Promise<CartResponse> {
		return this.fetch(new URL(this.updateCartItemUrl).toString(), {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(request),
		});
	}

	public async addCartItem(request: CartItemUpdate): Promise<CartResponse> {
		return this.fetch(new URL(this.addToCartUrl).toString(), {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(request),
		});
	}
}
